<!-- section1 -->
<section class=" text-white py-24 p-8" [style.background-color]="this.loadeddata?.PrimaryColor">
  <div class="w-full md:max-w-8xl mx-auto grid md:grid-cols-2 md:gap-x-24 md:p-[60px] md:p-24">
    <div>
      <h2 class="text-3xl md:text-7xl font-extrabold mb-4 text-white">Why Choose <br> {{this.loadeddata?.Name}}?</h2>
      <p class="text-lg md:text-2xl mb-4">
        {{this.loadeddata?.Name}} is the only phone plan that gives back to {{ this.loadeddata?.ShortName === 'Bear' ?
        '' : 'the ' + this.loadeddata?.CollegeName + ' and ' }} {{ this.loadeddata?.ShortName ===
        'Bear' ? 'Cal' : this.loadeddata?.CollegeNameAcronym }} Athletics. We
        turn your monthly
        plan
        into a powerful show of school pride.
      </p>
      <p class="text-md md:text-xl">
        Every time you pay your bill, you help recruit top talent, strengthen programs, and keep the
        {{this.loadeddata?.CollegeColors}} at
        the top of their game. Add in exclusive gameday perks and unforgettable
        {{ this.loadeddata?.ShortName === 'Bear' ?
        this.loadeddata?.ShortNamePlural : this.loadeddata?.ShortName }} experiences, and you're not just a fan—you're
        part of the team.
      </p>
      <p class="text-md md:text-xl mt-4">
        Choose {{this.loadeddata?.Name}}. Because real {{ this.loadeddata?.ShortNamePlural === 'Bears' ?
        'Golden ' + this.loadeddata?.ShortNamePlural : this.loadeddata?.ShortNamePlural }} don't just cheer from the
        sidelines—they power
        the program from within.
      </p>
    </div>
    <img [src]="tenant.getImg(tenant.WHY)" class="rounded-lg shadow-xl w-full"
      style="width: 654; height: 543; opacity: 1;" alt="Why Choose {{this.loadeddata?.Name}}?"
      title="Why Choose {{this.loadeddata?.Name}}?">
  </div>
</section>

<section class="husky-purple-bg py-4 px-4" id="ourPlans" #planssection
  [style.background-color]="this.loadeddata?.ThirdColor">
  <div class="text-center">
    <img src="{{ tenant.getImg(tenant.MARK2) }}" class="object-cover m-auto"
      alt="Partner of {{ this.loadeddata?.CollegeName }}" title="Partner of {{ this.loadeddata?.CollegeName }}">
  </div>
</section>

<section class="bg-white py-24 px-6">
  <div class="md:max-w-[90rem] mx-auto grid md:grid-cols-2 gap-x-[15rem]">
    <div>
      <h3 class="font-bold text-xl text-black mb-4">MAKE YOUR PLAN COUNT</h3>
      <h3 class="text-3xl md:text-6xl font-extrabold mb-5  " [ngStyle]="{ color: loadeddata?.PrimaryColor }"> Choose
        Where {{this.loadeddata?.Name}} <br> Contributes </h3>
      <p class="text-xl mb-12 text-black mb-5">When you switch to {{this.loadeddata?.Name}}, you're not just getting
        great wireless—you're fueling the future
        of {{ this.loadeddata?.ShortName === 'Bear' ?
        'Cal' : this.loadeddata?.CollegeName }}. You can choose the fund that is
        most important to you.
      </p>
      <ul class="space-y-2">
        <li>
          <p class="text-3xl font-extrabold text-black mt-10 mb-6">{{this.loadeddata?.Fund1}}</p>
          <p class="text-xl text-black mb-6">

            <span [innerHTML]="this.loadeddata?.Fund1Text"></span>


          </p>
        </li>
        <div class="border-t border-black  mt-4"></div>
        <li>
          <p class="text-3xl font-extrabold text-black mt-10 mb-6">{{this.loadeddata?.Fund2}}</p>
          <p class="text-xl text-black mb-6">
            <span [innerHTML]="this.loadeddata?.Fund2Text"></span>
        </li>
        <div class="border-t border-black mt-4 mb-12"></div>
        <li>
          <p class="text-3xl font-extrabold text-black mt-6 mb-6">{{this.loadeddata?.Fund3}}</p>
          <p class="text-xl text-black mb-12">

            <span [innerHTML]="this.loadeddata?.Fund3Text"></span>

          </p>
        </li>

      </ul>
    </div>

    <div>
      <h3 class="text-3xl md:text-6xl  font-extrabold mb-4 " [ngStyle]="{ color: loadeddata?.PrimaryColor }">How It
        Works</h3>
      <p class="mb-4 text-black text-xl md:text-2xl">{{this.loadeddata?.Name}} automatically contributes to {{
        this.loadeddata?.ShortName === 'Bear' ?
        'your chosen cause' : this.loadeddata?.CollegeNameAcronym }} every time you pay your bill.
      </p>

      <!-- New Math grid layout that is more readable-->
      <div class="rounded-xl shadow-md p-5 md:p-10 border border-gray-200 max-w-6xl mx-auto "
        [ngStyle]="{ color: loadeddata?.PrimaryColor }">
        <!-- Each number/operator gets its own grid cell -->


        <!-- Top row -->
        <div class="flex items-center">
          <p class="text-3xl md:text-6xl font-bold" [ngStyle]="{ color: loadeddata?.PrimaryColor }">
            $ 45
          </p>
          <span class="pl-11 text-left md:text-2xl text-black">What you pay</span>
        </div>

        <!-- Middle row -->
        <div class="mt-3 flex items-center">
          <p class="text-3xl md:text-6xl font-bold  mr-2 underline mb-5"
            [ngStyle]="{ color: loadeddata?.PrimaryColor }">
            x 7%*
          </p>
        </div>



        <!-- Bottom row -->
        <div class="flex items-center">
          <p class="text-3xl md:text-6xl font-bold " [ngStyle]="{ color: loadeddata?.PrimaryColor }">
            $ 3.15
          </p>
          <span class="pl-5 text-left md:text-2xl text-black">What we contribute</span>
        </div>

        <!-- Disclaimer -->

      </div>
      <p class="mt-4 text-xs text-black leading-snug">
        *Giveback percentages range from .25% to 7% depending on the plan you choose.
        See our <a target="_blank"
          href="https://moxee-customer-agreements.s3.us-east-2.amazonaws.com/terms-and-conditions/Moxee+Terms+of+Service+2025-06-26.pdf"
          class="underline">Terms of Service</a> for details.
      </p>

    </div>
  </div>

</section>
<!-- section3 -->
<section class="bg-gray-100 py-24 " [style.background-color]="this.loadeddata?.SeconndaryColor">
  <div class="max-w-[100rem] mx-auto">
    <h2 class="text-4xl md:text-6xl font-extrabold p-6 md:text-center mb-8 "
      [ngStyle]="{ color: loadeddata?.PrimaryColor }">Enjoy Your {{this.loadeddata?.Name}} Perks</h2>
    <div class="grid md:grid-cols-3 gap-6  ">
      <div class=" p-6  text-left">
        <h4 class="font-bold text-4xl mb-4 " [ngStyle]="{ color: loadeddata?.PrimaryColor }">
          {{this.loadeddata?.Perk1Name}}</h4>
        <p class="text-black text-xl">{{this.loadeddata?.Perk1Text}}</p>
      </div>
      <div class=" p-6  text-left">
        <h4 class="font-bold text-4xl mb-4 " [ngStyle]="{ color: loadeddata?.PrimaryColor }">Game Day Seat Upgrades</h4>
        <p class="text-black text-xl">
          Get closer to the action with the {{this.loadeddata?.Name}} Seat Upgrade perk. On game day, customers have a
          chance to score surprise seat upgrades at {{this.loadeddata?.StadiumName}} and other
          {{ this.loadeddata?.ShortName === 'Bear' ? 'Cal' : this.loadeddata?.CollegeNameAcronym }} sporting events—just
          for being part of the {{this.loadeddata?.Name}}
          team.
        </p>
      </div>
      <div class=" p-6   text-left">
        <h4 class="font-bold text-4xl mb-4 " [ngStyle]="{ color: loadeddata?.PrimaryColor }">Premium Giveaways</h4>
        <p class="text-black text-xl">{{this.loadeddata?.Name}} connects you to exclusive
          {{ this.loadeddata?.ShortName === 'Bear' ? 'Cal' :
          this.loadeddata?.CollegeName }} experiences. Customers get chances to win special giveaways—including
          pregame hospitality tent access, signed gear, and more. It's your all-access pass to the traditions and spirit
          of {{this.loadeddata?.ShortName}} {{ this.loadeddata?.ShortName === 'Bear' ? 'Territory' : 'Nation' }}.
        </p>
      </div>

    </div>
  </div>
</section>
<!-- Plan Section -->
<section class="bg-white py-24 p-6 md:text-center">
  <div class="max-w-[100rem] mx-auto">
    <h2 class="text-4xl md:text-5xl font-extrabold mb-4 " [ngStyle]="{ color: loadeddata?.PrimaryColor }">Choose Your
      {{this.loadeddata?.Name}} Plan.</h2>
    <p class="md:p-6 text-2xl md:text-3xl text-black ">Because real {{this.loadeddata?.FanNickName}} don't cheer from
      the sidelines—they power the program from within.</p>
  </div>



  <div class="mx-auto md:p-24" [ngClass]="{
    'max-w-8xl': facultyEnabled,
    'max-w-4xl': !facultyEnabled
  }">
    <div class="grid grid-cols-1  gap-8 mt-10" [ngClass]="{
    'md:grid-cols-3': facultyEnabled,
    'md:grid-cols-2': !facultyEnabled
  }">

      <div
        class="border border-gray-300 rounded-xl px-6 shadow hover:shadow-md transition duration-300 flex flex-col h-full "
        [style.background-color]="this.loadeddata?.SeconndaryColor">
        <h3 class="text-3xl md:text-5xl font-bold  mt-20 mb-8 " [ngStyle]="{ color: loadeddata?.PrimaryColor }"> Alum or
          Fan Plans</h3>
        <p class="text-black text-xl md:text-3xl mb-12">
          We contribute to {{ this.loadeddata?.ShortName === 'Bear' ? 'Cal Athletics' : this.loadeddata?.CollegeNameAcronym}} every time you pay your bill.
        </p>
        <a (click)="trackevent('why.fanplans')" routerLink="../fan"
          class="self-center mt-auto text-xl text-white px-6 py-3 mb-24 rounded-lg font-semibold hover:bg-[#3a2469] transition"
          [style.background-color]="this.loadeddata?.PrimaryColor">
          See Fan Plans
        </a>
      </div>


      <div
        class="border border-gray-300 rounded-xl px-6  shadow hover:shadow-md transition duration-300 flex flex-col h-full"
        [style.background-color]="this.loadeddata?.SeconndaryColor">
        <h3 class="text-3xl md:text-5xl font-bold  mt-20 mb-8" [ngStyle]="{ color: loadeddata?.PrimaryColor }">Student
          Plans</h3>
        <p class="text-black text-xl md:text-3xl mb-12">
          Plans start at $15/month.
        </p>
        <a (click)="trackevent('why.studentplans')" routerLink="../student"
          class="self-center mt-auto text-xl text-white px-6 py-3 mb-24 rounded-lg font-semibold hover:bg-[#3a2469] transition"
          [style.background-color]="this.loadeddata?.PrimaryColor">
          See Student Plans
        </a>
      </div>

      <div *ngIf="facultyEnabled"
        class="border border-gray-300 rounded-xl px-8  shadow hover:shadow-md transition duration-300 flex flex-col h-full"
        [style.background-color]="this.loadeddata?.SeconndaryColor">
        <h3 class="text-3xl md:text-5xl font-bold  mt-20 mb-8" [ngStyle]="{ color: loadeddata?.PrimaryColor }">Faculty
          or Staff Plans</h3>
        <p class="text-black text-xl md:text-3xl mb-6">
          20% off Fan plans.
        </p>
        <a (click)="trackevent('why.facultyplans')" routerLink="../shop-faculty-plans"
          class="self-center mt-auto text-xl text-white px-6 py-3 mb-24 rounded-lg font-semibold hover:bg-[#3a2469] transition"
          [style.background-color]="this.loadeddata?.PrimaryColor">
          See Faculty Plans
        </a>
      </div>
    </div>

  </div>
</section>